import pic3 from "../logo/my-img.jpeg";
import pic1 from "../logo/Prabhas.jpg";
import pic2 from "../logo/Ashamsa.jpg";
import pic4 from "../logo/Koshish.jpg";
import pic5 from "../logo/Bishwo.jpg";
import pic6 from "../logo/Aavash.jpg";
import dineshPic from "../assets/teams/dinesh.png";
import abhishekPic from "../assets/teams/abhishek.jpeg";
import lochanpic from "../assets/teams/lochan.png";
import barnettpic from "../assets/teams/barnett.jpg";
import georgePic from "../assets/teams/george.png";
import srijanPic from "../assets/teams/Srijan.jpg";
import prasannaPic from "../assets/teams/prasanna.png";
import prasiddhiPic from "../assets/teams/prasiddhi.png";
import isaacPic from "../assets/teams/isaac.png";
import anmolPic from "../assets/teams/anmol.png";
import prajwolPic from "../assets/teams/prajwol.png";
import jeevanPic from "../assets/teams/jeevan.png";
import prabinPic from "../assets/teams/prabin.png";
import defaultPic from "../assets/teams/defaultProfilePic.png";
import karinaPic from "../assets/teams/KarinaKarki.JPG";
import samayaraPic from "../assets/teams/samayara.JPG";
import nishuPic from "../assets/teams/nishu.png";
import suruchiPic from "../assets/teams/suruchi.jpeg";
import deepikaPic from "../assets/teams/deepika.jpeg";
import sagarPic from "../assets/teams/sagar.png";
import samratPic from "../assets/teams/samrat.png";

export const timelineData = [
  {
    year: "2026-2027",
    members: [
      {
        name: "Prasiddhi Luitel",
        role: "President",
        image: prasiddhiPic,
        linkedin: "https://www.linkedin.com/in/prasiddhix/",
      },
      {
        name: "Prajwol Ramtel",
        role: "External Vice President",
        image: prajwolPic,
        linkedin: "https://www.linkedin.com/in/prajwol-ramtel-00a6a9283/",
      },
      {
        name: "Prasanna Jha",
        role: "Internal Vice President",
        image: prasannaPic,
        linkedin: "https://www.linkedin.com/in/prasanna-kumar-jha-77b82230a/",
      },
      {
        name: "Karina Karki",
        role: "Secretary",
        image: karinaPic,
        linkedin: "https://www.linkedin.com/in/karina-karkii",
      },
      {
        name: "Samayara Rijal",
        role: "Director of Marketing and Public Relations",
        image: samayaraPic,
        linkedin: "",
      },
      {
        name: "Deepika Baruwal",
        role: "Treasurer",
        image: deepikaPic,
        linkedin: "https://www.linkedin.com/in/deepika-baruwal-870243252/",
      },
      {
        name: "Sagar Banstola",
        role: "Technical Lead",
        image: sagarPic,
        linkedin: "https://www.linkedin.com/in/sagar-banstola-1032b337b/",
      },
      {
        name: "Samrat Bhusal",
        role: "Graphics Design",
        image: samratPic,
        linkedin: "",
      },
      {
        name: "Kritika Pandey",
        role: "Freshmen Representative",
        image: "",
        linkedin: "",
      },
      {
        name: "William Barnett",
        role: "Faculty/Staff",
        image: barnettpic,
        linkedin: "",
      },
    ],
  },
  {
    year: "2025-2026",
    members: [
      {
        name: "Abhishek Amgain",
        role: "President",
        image: abhishekPic,
        linkedin: "https://www.linkedin.com/in/abhishek-amgain-04b642265/",
      },
      {
        name: "Prasiddhi Luitel",
        role: "External Vice President",
        image: prasiddhiPic,
        linkedin: "https://www.linkedin.com/in/prasiddhix/",
      },
      {
        name: "Jeevan Parajuli",
        role: "Internal Vice President",
        image: jeevanPic,
        linkedin: "https://www.linkedin.com/in/jeevanparajuli856/",
      },
      {
        name: "Karina Karki",
        role: "Secretary",
        image: karinaPic,
        linkedin: "https://www.linkedin.com/in/karina-karkii",
      },
      {
        name: "Prajwol Ramtel",
        role: "Treasurer",
        image: prajwolPic,
        linkedin: "https://www.linkedin.com/in/prajwol-ramtel-00a6a9283/",
      },
      {
        name: "Prasanna Jha",
        role: "Technical Lead",
        image: prasannaPic,
        linkedin: "https://www.linkedin.com/in/prasanna-kumar-jha-77b82230a/",
      },
      {
        name: "Anmol Subedi",
        role: "Graphic Design Lead",
        image: anmolPic,
        linkedin: "https://www.linkedin.com/in/anmolsubedi/",
      },
      {
        name: "Isaac Iyobebe",
        role: "Public Relations Officer",
        image: isaacPic,
        linkedin: "https://www.linkedin.com/in/isaac-isidahome-iyobebe/",
      },
      {
        name: "Samayara Rijal",
        role: "Event Manager",
        image: samayaraPic,
        linkedin: "",
      },
      {
        name: "Prabin Pokhrel",
        role: "Freshman Representative",
        image: prabinPic,
        linkedin: "",
      },
      {
        name: "William Barnett",
        role: "Faculty/Staff",
        image: barnettpic,
        linkedin: "",
      },
    ],
  },
  {
    year: "2023-2024",
    members: [
      {
        name: "Dinesh Chhantyal",
        role: "President",
        image: dineshPic,
        linkedin: "https://linkedin.com/in/dineshchhantyal",
      },
      {
        name: "Abhishek Amgain",
        role: "External Vice President",
        image: abhishekPic,
        linkedin: "",
      },
      {
        name: "George Khawas",
        role: "Internal Vice President",
        image: georgePic,
        linkedin: "",
      },
      {
        name: "Biswash Kunwar",
        role: "Secretary",
        linkedin: "",
      },
      {
        name: "Suruchi Bista",
        role: "Treasurer",
        image: suruchiPic,
        linkedin: "https://www.linkedin.com/in/suruchi-bista/",
      },
      {
        name: "Lochan Acharya",
        role: "Technical Lead",
        image: lochanpic,
        linkedin: "https://www.linkedin.com/in/lochanacharya13/",
      },
      {
        name: "Nishu Shrestha",
        role: "Graphic Design Lead",
        image: nishuPic,
        linkedin: "https://www.linkedin.com/in/nishushrestha/",
      },
      {
        name: "Prasiddhi Luitel",
        role: "Public Relations Officer",
        image: prasiddhiPic,
        linkedin: "https://www.linkedin.com/in/prasiddhix/",
      },
      {
        name: "Jeevan Parajuli",
        role: "Sophomore Representative",
        image: jeevanPic,
        linkedin: "https://www.linkedin.com/in/jeevanparajuli856/",
      },
      {
        name: "Isaac Iyobebe",
        role: "Sophomore Representative",
        image: isaacPic,
        linkedin: "https://www.linkedin.com/in/isaac-isidahome-iyobebe/",
      },
      {
        name: "Srijan Dahal",
        role: "Freshman Representative",
        image: srijanPic,
        linkedin: "",
      },
      {
        name: "Aarushka Kattel",
        role: "Freshman Representative",
        linkedin: "",
      },
      {
        name: "Bishwo Dahal",
        role: "Student Advisor",
        linkedin: "https://www.linkedin.com/in/bishwo-dahal/",
        image: pic5,
      },
      {
        name: "William Barnett",
        role: "Faculty/Staff",
        image: barnettpic,
        linkedin: "",
      },
    ],
  },
  {
    year: "2022-2023",
    members: [
      {
        name: "Prabash GC",
        role: "GDSC Lead",
        image: pic1,
        linkedin: "https://www.linkedin.com/in/prabhash-g-c-751b11211/",
      },
      {
        name: "Ashamsha Adhikari",
        role: "Vice President",
        image: pic2,
        linkedin: "https://www.linkedin.com/in/ashamsa/",
      },
      {
        name: "Evan Ranjitkar",
        role: "Web Master",
        image: pic3,
        linkedin: "https://www.linkedin.com/in/evan-ranjitkar-664b22197/",
      },
      {
        name: "Koshish Shrestha",
        role: "Secretary",
        image: pic4,
        linkedin: "https://www.linkedin.com/in/koshish1392/",
      },
      {
        name: "Bishwo Dahal",
        role: "Vice President",
        image: pic5,
        linkedin: "https://www.linkedin.com/in/bishwo-dahal/",
      },
      {
        name: "Aavash Kuikel",
        role: "Treasurer",
        image: pic6,
        linkedin: "https://www.linkedin.com/in/aavash-kuikel-62b699224/",
      },
    ],
  },
];
